function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ItemMemberLevel, TeamMemberLevel, UserType } from "sprout-graphql";
import { useCallback } from "react";
import { usePopoverDialogState } from "sprout-ui-dom/dist/PopoverDialog";
import { EditSectionPopoverDialog } from "@sprout/client-components/dist/PopoverDialog";
import { PopoverReference, PopoverTrigger } from "sprout-ui-dom/dist/Popover";
import { useActionRegistryGlobalHandler } from "@sprout/list-navigation";
import { useTopicPage } from "../TopicPageContext";
import TopicPageHeaderH1 from "./TopicPageHeaderH1";
const TopicPageHeaderTitle = (props)=>{
    const { topic  } = props;
    const { title , isRootTopic , rootTopicOrSelf  } = topic;
    const { memberLevel , owner , special  } = rootTopicOrSelf || {};
    const isSpecial = !!special;
    const { isOwnerOrAdmin  } = useTopicPage();
    const canEditTopic = isRootTopic && (memberLevel === ItemMemberLevel.Owner || (owner === null || owner === void 0 ? void 0 : owner.type) === UserType.Team && owner.memberLevel === TeamMemberLevel.Owner);
    const canEditSection = !isRootTopic && isOwnerOrAdmin;
    const disabled = !(canEditTopic || canEditSection) || isSpecial && !!isRootTopic;
    const popoverDialogState = usePopoverDialogState();
    const { onOpenChange  } = popoverDialogState;
    useActionRegistryGlobalHandler("PAGE_EDIT_TOPIC", useCallback(()=>{
        if (canEditTopic || canEditSection) {
            onOpenChange(true);
            return true;
        }
        return false;
    }, [
        canEditSection,
        canEditTopic,
        onOpenChange
    ]), {
        skip: disabled
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(EditSectionPopoverDialog, _objectSpread({
                placement: "bottom",
                topic: topic,
                isRootTopic: !!topic.isRootTopic,
                showDescription: true
            }, popoverDialogState)),
            /*#__PURE__*/ _jsx(PopoverReference, _objectSpread({}, popoverDialogState, {
                children: /*#__PURE__*/ _jsx(PopoverTrigger, _objectSpread({}, popoverDialogState, {
                    disabled: disabled,
                    children: /*#__PURE__*/ _jsx(TopicPageHeaderH1, {
                        title: title || "No title",
                        ref: popoverDialogState.setReferenceElement
                    })
                }))
            }))
        ]
    });
};
export default TopicPageHeaderTitle;
